import { Component, OnInit, Input, ViewChild } from '@angular/core';
import { ApiService } from '../api.service';
import { Observable } from 'rxjs';
import { Inject, Injectable } from '@angular/core';
import { LOCAL_STORAGE, WebStorageService } from 'angular-webstorage-service';
import { HttpClient } from '@angular/common/http';
import { User } from '../User';
import { AlertService } from '../alert.service';
import { ModalDirective } from 'angular-bootstrap-md';
import {MatDialog, MatDialogRef, MAT_DIALOG_DATA} from '@angular/material';
import { EditMobileDialogComponent } from '../edit-mobile-dialog/edit-mobile-dialog.component';


@Component({
  selector: 'app-open-otpdialog',
  templateUrl: './open-otpdialog.component.html',
  styleUrls: ['./open-otpdialog.component.scss']
})
export class OpenOtpdialogComponent implements OnInit {
  private user: User = new User();
  mobileNumber: String = "";
  public showMsg;
  mobileverifyMsg:string =""; //shows msg mobile verified or not
  private debugData: Boolean = true;  // to show and hide the data in console log
 otpErrorMsg: string = ""; // to display the error msg on otp popup
  
  constructor(@Inject(LOCAL_STORAGE) private storage: WebStorageService, private apiService: ApiService,
 private httpClient: HttpClient, private alertService: AlertService, 
 public mob_dialogRef: MatDialogRef<EditMobileDialogComponent>, public otp_dialogRef: MatDialogRef<OpenOtpdialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: User, public dialog: MatDialog) {

}
onotpNoClick(): void {
  this.otp_dialogRef.close();
}
mobile:number;
openMobileEditDialog() {
  const mob_dialogRef = this.dialog.open(EditMobileDialogComponent, {
       data: {mobile: this.user.mobile}
  });

  mob_dialogRef.afterClosed().subscribe(result => {
    console.log('The dialog wasotp closed');
    //this.initCustData();
    //this.OTPModal.show();
    //this.email = this.user.email;
    console.log("updated" +this.user.username)
    this.data=this.user;
    this.initCustData();
   // this.mobile=this.data.mobile;
    console.log(this.mobile)
  });
}

  ngOnInit() {
  }
  initCustData() {
    if (this.apiService.checkUserLoggedIn() == true) {
    let urrr = this.apiService.cutomerDetails + this.apiService.getFromLocalData('custDD');
    this.httpClient.get(urrr)
   .subscribe(
    data => this.intilizeComponent(data),
    error => this.showError(error)
   );
   
   } else {
    console.log("User Not Logged In. Please login!")
   }
   
   }
   refresh(): void {
    window.location.reload();
  }
    intilizeComponent(data) {
    this.user = data;
    console.log("user" +this.user.mobile);
    this.mobile=this.user.mobile;
    if(this.user.mobileVerified == 0)
    {
     this.mobileverifyMsg="mobile not verified";
    }
    else{
     this.mobileverifyMsg="mobile verified";
    }
     }
   
    showError(msg) {
    console.log("Error Found in server");
   }

   // <!-- start of OTP verify function  -->
verifyOtpN(otpToVerify) {
  let postData = { 'mobile': this.user.mobile, 'otp': otpToVerify }
  if (this.debugData) {
    console.log("very otp json data is ")
    console.log(postData);
  }
  this.httpClient.post(this.apiService.verifyOTP_URL, postData)
    .subscribe(
      (detail: any) => {
        if (this.debugData) {
          console.log("very otp function API Data ")
          console.log(detail);
        }
        if (detail.status == true) {
          if (this.debugData) {
            console.log("Success OTP Verified")
          }
          this.user = detail.obj;
          this.otpErrorMsg = "OTP Verified";
          this.refresh();
        } else {
          if (this.debugData) {
            console.log(" OTP not Verified")
          }
          this.otpErrorMsg = "Incorrect OTP";
        }
      }
    )
}
// <!-- end of OTP verify function  -->

// <!-- Start of OTP send function  -->
sendOtpN(mobileNumber, custId) {
  let postData = { 'mobile': mobileNumber, 'id': custId };
  this.httpClient.post(this.apiService.sendOtpURL, postData)
    .subscribe(
      (detail: any) => {
        if (this.debugData) {
          console.log("Send OTP Api data");
          console.log(detail);
        }
        if (detail.status == true) {
          return true;
        } else {
          return false;
        }
      }
    )
}
// <!-- end of OTP send function  -->

// <!-- start of OTP Resend function  -->
resendOtpNow() {
  if (this.apiService.checkUserLoggedIn() == true) {
    let postData = { 'mobile': this.user.mobile };
    this.httpClient.post(this.apiService.resendURL, postData)
      .subscribe(
        (detail: any) => {
          if (this.debugData) {
            console.log("resend otp function API data");
            console.log(detail);
          }
          if (detail.status == true) {
            this.otpErrorMsg = "OTP sent"
          } else {
            this.otpErrorMsg = "OTP sending fail"
          }
        },
        (err) => {
          this.otpErrorMsg = "Some error occured. Please try again."
        });
  } else {
    //this.warn("Please Login");
  }
}
// <!-- end of OTP Resend function  -->



}



// WEBPACK FOOTER //
// C:/unnati/latestWebCode29march/src/app/open-otpdialog/open-otpdialog.component.ts